import { MessageSourceKey } from './interface';
import { masterMessageHub } from './instance/master';
import PushCode, { isPushSourceKey } from './instance/pushSource/key';
import CustomSourceKey, { isCustomSourceKey } from './instance/customSource/key';

// 由于实参来自于外部（其他页面的 `postMessage`），因此形参类型定义为 unknown
const bridge = {
    'messageHub.registerPushSource': (key: unknown) => {
        if (isPushSourceKey(key)) {
            masterMessageHub.registerPushSource(key);
        }
    },
    'messageHub.registerCustomSource': (key: unknown) => {
        if (isCustomSourceKey(key)) {
            masterMessageHub.registerCustomSource(key);
        }
    },
};

export type MessageHubBridge = typeof bridge;

export const createBridgeClient = (
    postMessageToParent: (method: keyof MessageHubBridge, args?: any) => void,
) => {
    return {
        registerPushSource: <PK extends MessageSourceKey = PushCode>(key: PK) => {
            postMessageToParent('messageHub.registerPushSource', [key]);
        },
        registerCustomSource: <CK extends MessageSourceKey = CustomSourceKey>(key: CK) => {
            postMessageToParent('messageHub.registerCustomSource', [key]);
        },
    };
};

export default bridge;
